import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NudgeConfig } from "src/app/shared/models/nudge.model";

@Component({
  selector: "app-nudge-container",
  templateUrl: "./nudge-container.component.html",
  styleUrls: ["./nudge-container.component.scss"],
})
export class NudgeContainerComponent {
  private static readonly CLOSE_ANIMATION_MS = 420;
  @Input() nudges: NudgeConfig[] = [];
  @Output() ctaClick = new EventEmitter<NudgeConfig>();
  @Output() closeClick = new EventEmitter<NudgeConfig>();
  closingNudgeIds = new Set<string>();

  isTaskNudge(nudge: NudgeConfig) {
    return ["start-task", "start-recurring-task"].includes(nudge.id);
  }

  isReminderNudge(nudge: NudgeConfig) {
    return nudge.id === "start-reminder";
  }

  isAttendanceNudge(nudge: NudgeConfig) {
    return nudge.id === "start-attendance";
  }

  isWorkflowNudge(nudge: NudgeConfig) {
    return nudge.id === "start-workflow-template";
  }

  isSubtaskNudge(nudge: NudgeConfig) {
    return nudge.id === "start-subtask";
  }

  isPriorityNudge(nudge: NudgeConfig) {
    return nudge.id === "start-priority";
  }

  isDailyReportNudge(nudge: NudgeConfig) {
    return nudge.id === "start-daily-report";
  }

  isChecklistNudge(nudge: NudgeConfig) {
    return nudge.id === "start-checklist";
  }

  isTimesheetNudge(nudge: NudgeConfig) {
    return nudge.id === "start-timesheet-approval";
  }

  isApprovalNudge(nudge: NudgeConfig) {
    return nudge.id === "start-task-approval";
  }

  isOverdueNudge(nudge: NudgeConfig) {
    return nudge.id === "start-overdue-task";
  }

  isProjectNudge(nudge: NudgeConfig) {
    return nudge.id === "start-project";
  }

  onCtaClick(nudge: NudgeConfig) {
    this.ctaClick.emit(nudge);
  }

  onCloseClick(event: Event, nudge: NudgeConfig) {
    event.preventDefault();
    event.stopPropagation();

    if (this.closingNudgeIds.has(nudge.id)) {
      return;
    }
    this.closingNudgeIds.add(nudge.id);
    setTimeout(() => {
      this.closeClick.emit(nudge);
      this.closingNudgeIds.delete(nudge.id);
    }, NudgeContainerComponent.CLOSE_ANIMATION_MS);
  }

  closeAll() {
    if (!this.nudges?.length) {
      return;
    }

    this.nudges.forEach((nudge) => {
      if (!this.closingNudgeIds.has(nudge.id)) {
        this.closingNudgeIds.add(nudge.id);
      }
    });

    setTimeout(() => {
      [...this.nudges].forEach((nudge) => this.closeClick.emit(nudge));
      this.closingNudgeIds.clear();
    }, NudgeContainerComponent.CLOSE_ANIMATION_MS);
  }
}
